import React, { useState } from "react";
import Layout from "../Components/Layout";
import { Container, Row, Col, FormControl } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import LayoutCoach from "../Components/LayoutCoach";
import { useDispatch, useSelector } from "react-redux";
import { getCoachDetails } from "../Redux/Actions/userActions";
import { useQuery } from "@tanstack/react-query";
import { coachDetails } from "../Redux/Reducers/CoachSlice";
import toast from "react-hot-toast";
import {
  getCoachDetailsInCoachside,
  getUserProfile,
} from "../Redux/Actions/coachAction";

export default function MyProfileCoach() {
  const dispatch = useDispatch();
  const BASE_URL = "https://api.mindrepublic.com/";
  const navigate = useNavigate();

  const ingerman = useSelector((state) => state.homedata.selectedLang);
  console.log(ingerman);

  const dayTranslations = {
    Monday: ingerman === "de" ? "Montag" : "Monday",
    Tuesday: ingerman === "de" ? "Dienstag" : "Tuesday",
    Wednesday: ingerman === "de" ? "Mittwoch" : "Wednesday",
    Thursday: ingerman === "de" ? "Donnerstag" : "Thursday",
    Friday: ingerman === "de" ? "Freitag" : "Friday",
    Saturday: ingerman === "de" ? "Samstag" : "Saturday",
    Sunday: ingerman === "de" ? "Sonntag" : "Sunday",
    "All Days": ingerman === "de" ? "Alle Tage" : "All Days",
    // ...
  };



  // ================================================get user data from redux===========================================

  const userData = useSelector((state) => state?.registerUserdata?.user);

  console.log(userData, "data");

  // ===============================================react states=======================================================

  const [edit, setEdit] = useState(false);

  // ========================================fetch data by usequery===============================

  const { isPending, data, isSuccess, isError } = useQuery({
    queryKey: ["coachdetailscoachSide"],
    queryFn: getUserProfile,
  });

  {
    // isSuccess && dispatch(coachDetails(data));
  }

  {
    isError && toast.error(data?.message || "Something went wrong");
  }

  console.log(data, "data");

  return (
    <>
      <LayoutCoach>
        <div className="right-side">
          <div className="edit-page-i">
            <Link
              // to="/edit-profile"
              onClick={() => setEdit(true)}
            >
              {edit ? (
                ""
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                >
                  <rect width="36" height="36" rx="18" fill="white" />
                  <path
                    d="M13.1596 23.0561C12.7204 23.0561 12.31 22.9054 12.0148 22.6255C11.6404 22.2738 11.4604 21.7427 11.5252 21.1686L11.7916 18.8432C11.842 18.4054 12.1084 17.8241 12.418 17.5083L18.3292 11.2716C19.8052 9.71418 21.346 9.67112 22.9084 11.1424C24.4708 12.6137 24.514 14.1495 23.038 15.7069L17.1268 21.9437C16.8244 22.2666 16.2628 22.5681 15.8236 22.6398L13.5052 23.0346C13.3828 23.0417 13.2748 23.0561 13.1596 23.0561ZM20.6404 11.1352C20.086 11.1352 19.6036 11.4797 19.114 11.9964L13.2028 18.2404C13.0588 18.3911 12.8932 18.7499 12.8644 18.9581L12.598 21.2834C12.5692 21.5202 12.6268 21.714 12.7564 21.836C12.886 21.958 13.0804 22.0011 13.318 21.9652L15.6364 21.5705C15.8452 21.5346 16.1908 21.348 16.3348 21.1973L22.246 14.9605C23.1388 14.0132 23.4628 13.1376 22.1596 11.9175C21.5836 11.3649 21.0868 11.1352 20.6404 11.1352Z"
                    fill="black"
                  />
                  <path
                    d="M21.6581 16.908H21.6077C20.5165 16.8013 19.492 16.3358 18.6955 15.5847C17.899 14.8337 17.3758 13.8398 17.2085 12.7597C17.1653 12.4655 17.3669 12.1928 17.6621 12.1425C17.9573 12.0995 18.2309 12.3004 18.2813 12.5947C18.4131 13.4391 18.8227 14.216 19.4456 14.8032C20.0686 15.3904 20.8696 15.7546 21.7229 15.8386C22.0181 15.8674 22.2341 16.1329 22.2053 16.4272C22.1693 16.6999 21.9317 16.908 21.6581 16.908Z"
                    fill="black"
                  />
                  <path
                    d="M24.2944 25.3769H11.3344C11.0392 25.3769 10.7944 25.1321 10.7944 24.8369C10.7944 24.5417 11.0392 24.2969 11.3344 24.2969H24.2944C24.5896 24.2969 24.8344 24.5417 24.8344 24.8369C24.8344 25.1321 24.5896 25.3769 24.2944 25.3769Z"
                    fill="black"
                  />
                </svg>
              )}
            </Link>
          </div>
          <div className="notify-page-i">
            <Link to="/settings-coach">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="28"
                viewBox="0 0 27 28"
                fill="none"
              >
                <path
                  d="M0.68454 16.7192C0.305023 14.9268 0.305023 13.0748 0.68454 11.2823C2.14935 11.4539 3.4294 10.9696 3.84641 9.96135C4.26474 8.95182 3.70389 7.70476 2.54524 6.79024C3.54426 5.25461 4.85373 3.94514 6.38936 2.94612C7.30256 4.10345 8.55094 4.66561 9.56047 4.24729C10.57 3.82896 11.0543 2.55022 10.8814 1.08542C12.6739 0.705902 14.5259 0.705902 16.3184 1.08542C16.1468 2.55022 16.6311 3.83028 17.6393 4.24729C18.6489 4.66561 19.8959 4.10477 20.8104 2.94612C22.3461 3.94514 23.6555 5.25461 24.6546 6.79024C23.4972 7.70344 22.9351 8.95182 23.3534 9.96135C23.7717 10.9709 25.0505 11.4552 26.5153 11.2823C26.8948 13.0748 26.8948 14.9268 26.5153 16.7192C25.0505 16.5477 23.7704 17.032 23.3534 18.0402C22.9351 19.0497 23.4959 20.2968 24.6546 21.2113C23.6555 22.747 22.3461 24.0564 20.8104 25.0554C19.8972 23.8981 18.6489 23.3359 17.6393 23.7543C16.6298 24.1726 16.1455 25.4513 16.3184 26.9161C14.5259 27.2957 12.6739 27.2957 10.8814 26.9161C11.053 25.4513 10.5687 24.1713 9.56047 23.7543C8.55094 23.3359 7.30388 23.8968 6.38936 25.0554C4.85373 24.0564 3.54426 22.747 2.54524 21.2113C3.70257 20.2981 4.26474 19.0497 3.84641 18.0402C3.42808 17.0307 2.14935 16.5464 0.68454 16.7192ZM3.04274 14.2779C4.49435 14.6804 5.69127 15.6002 6.28511 17.0307C6.87763 18.4625 6.681 19.9603 5.93936 21.2694C6.06605 21.404 6.19669 21.5346 6.3313 21.6613C7.64171 20.9197 9.13818 20.7244 10.57 21.3156C12.0005 21.9094 12.9203 23.1063 13.3228 24.5579C13.5075 24.5632 13.6923 24.5632 13.877 24.5579C14.2795 23.1063 15.1993 21.9094 16.6298 21.3156C18.0616 20.723 19.5594 20.9197 20.8685 21.6613C21.0031 21.5346 21.1338 21.404 21.2604 21.2694C20.5188 19.959 20.3235 18.4625 20.9147 17.0307C21.5085 15.6002 22.7055 14.6804 24.1571 14.2779C24.1623 14.0932 24.1623 13.9084 24.1571 13.7237C22.7055 13.3212 21.5085 12.4014 20.9147 10.9709C20.3222 9.53906 20.5188 8.04127 21.2604 6.73218C21.1333 6.5981 21.0026 6.46741 20.8685 6.34024C19.5581 7.08188 18.0616 7.27719 16.6298 6.68599C15.1993 6.09215 14.2795 4.89523 13.877 3.44362C13.6923 3.43873 13.5075 3.43873 13.3228 3.44362C12.9203 4.89523 12.0005 6.09215 10.57 6.68599C9.13818 7.27851 7.64039 7.08188 6.3313 6.34024C6.19669 6.46693 6.06605 6.59757 5.93936 6.73218C6.681 8.04258 6.87631 9.53906 6.28511 10.9709C5.69127 12.4014 4.49435 13.3212 3.04274 13.7237C3.03747 13.9084 3.03747 14.0932 3.04274 14.2779ZM13.5999 17.9597C12.5499 17.9597 11.543 17.5426 10.8005 16.8002C10.0581 16.0577 9.64097 15.0508 9.64097 14.0008C9.64097 12.9508 10.0581 11.9438 10.8005 11.2014C11.543 10.4589 12.5499 10.0418 13.5999 10.0418C14.6499 10.0418 15.6568 10.4589 16.3993 11.2014C17.1417 11.9438 17.5588 12.9508 17.5588 14.0008C17.5588 15.0508 17.1417 16.0577 16.3993 16.8002C15.6568 17.5426 14.6499 17.9597 13.5999 17.9597ZM13.5999 15.3204C13.9499 15.3204 14.2855 15.1814 14.533 14.9339C14.7805 14.6864 14.9195 14.3508 14.9195 14.0008C14.9195 13.6508 14.7805 13.3151 14.533 13.0677C14.2855 12.8202 13.9499 12.6811 13.5999 12.6811C13.2499 12.6811 12.9143 12.8202 12.6668 13.0677C12.4193 13.3151 12.2803 13.6508 12.2803 14.0008C12.2803 14.3508 12.4193 14.6864 12.6668 14.9339C12.9143 15.1814 13.2499 15.3204 13.5999 15.3204Z"
                  fill="black"
                />
              </svg>
            </Link>
          </div>
          <div className="main-content">
            <h2>{ingerman=="de" ? "Mein Profil" : "My Profile"}</h2>
            <div className="coach-details">
              <Row>
                <Col lg={6}>
                  <div className="coach-profle-img">
                    <img
                      src={
                        userData?.profile_image
                          ? `${BASE_URL}${userData?.profile_image}`
                          : require("../Assets/images/place_holder.png")
                      }
                    />
                    <button>
                      {edit ? (
                        <div onClick={() => navigate("/edit-profile")}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                          >
                            <rect width="36" height="36" rx="18" fill="white" />
                            <path
                              d="M13.1596 23.0561C12.7204 23.0561 12.31 22.9054 12.0148 22.6255C11.6404 22.2738 11.4604 21.7427 11.5252 21.1686L11.7916 18.8432C11.842 18.4054 12.1084 17.8241 12.418 17.5083L18.3292 11.2716C19.8052 9.71418 21.346 9.67112 22.9084 11.1424C24.4708 12.6137 24.514 14.1495 23.038 15.7069L17.1268 21.9437C16.8244 22.2666 16.2628 22.5681 15.8236 22.6398L13.5052 23.0346C13.3828 23.0417 13.2748 23.0561 13.1596 23.0561ZM20.6404 11.1352C20.086 11.1352 19.6036 11.4797 19.114 11.9964L13.2028 18.2404C13.0588 18.3911 12.8932 18.7499 12.8644 18.9581L12.598 21.2834C12.5692 21.5202 12.6268 21.714 12.7564 21.836C12.886 21.958 13.0804 22.0011 13.318 21.9652L15.6364 21.5705C15.8452 21.5346 16.1908 21.348 16.3348 21.1973L22.246 14.9605C23.1388 14.0132 23.4628 13.1376 22.1596 11.9175C21.5836 11.3649 21.0868 11.1352 20.6404 11.1352Z"
                              fill="black"
                            />
                            <path
                              d="M21.6581 16.908H21.6077C20.5165 16.8013 19.492 16.3358 18.6955 15.5847C17.899 14.8337 17.3758 13.8398 17.2085 12.7597C17.1653 12.4655 17.3669 12.1928 17.6621 12.1425C17.9573 12.0995 18.2309 12.3004 18.2813 12.5947C18.4131 13.4391 18.8227 14.216 19.4456 14.8032C20.0686 15.3904 20.8696 15.7546 21.7229 15.8386C22.0181 15.8674 22.2341 16.1329 22.2053 16.4272C22.1693 16.6999 21.9317 16.908 21.6581 16.908Z"
                              fill="black"
                            />
                            <path
                              d="M24.2944 25.3769H11.3344C11.0392 25.3769 10.7944 25.1321 10.7944 24.8369C10.7944 24.5417 11.0392 24.2969 11.3344 24.2969H24.2944C24.5896 24.2969 24.8344 24.5417 24.8344 24.8369C24.8344 25.1321 24.5896 25.3769 24.2944 25.3769Z"
                              fill="black"
                            />
                          </svg>
                        </div>
                      ) : (
                        ""
                      )}
                    </button>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="coach-profile-info">
                    <div className="profile-detail">
                      <div className="d-flex align-items-center justify-content-between">
                        <h3>{userData?.full_name}</h3>
                        <button>
                          {edit ? (
                            <div onClick={() => navigate("/edit-profile")}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                              >
                                <rect
                                  width="36"
                                  height="36"
                                  rx="18"
                                  fill="white"
                                />
                                <path
                                  d="M13.1596 23.0561C12.7204 23.0561 12.31 22.9054 12.0148 22.6255C11.6404 22.2738 11.4604 21.7427 11.5252 21.1686L11.7916 18.8432C11.842 18.4054 12.1084 17.8241 12.418 17.5083L18.3292 11.2716C19.8052 9.71418 21.346 9.67112 22.9084 11.1424C24.4708 12.6137 24.514 14.1495 23.038 15.7069L17.1268 21.9437C16.8244 22.2666 16.2628 22.5681 15.8236 22.6398L13.5052 23.0346C13.3828 23.0417 13.2748 23.0561 13.1596 23.0561ZM20.6404 11.1352C20.086 11.1352 19.6036 11.4797 19.114 11.9964L13.2028 18.2404C13.0588 18.3911 12.8932 18.7499 12.8644 18.9581L12.598 21.2834C12.5692 21.5202 12.6268 21.714 12.7564 21.836C12.886 21.958 13.0804 22.0011 13.318 21.9652L15.6364 21.5705C15.8452 21.5346 16.1908 21.348 16.3348 21.1973L22.246 14.9605C23.1388 14.0132 23.4628 13.1376 22.1596 11.9175C21.5836 11.3649 21.0868 11.1352 20.6404 11.1352Z"
                                  fill="black"
                                />
                                <path
                                  d="M21.6581 16.908H21.6077C20.5165 16.8013 19.492 16.3358 18.6955 15.5847C17.899 14.8337 17.3758 13.8398 17.2085 12.7597C17.1653 12.4655 17.3669 12.1928 17.6621 12.1425C17.9573 12.0995 18.2309 12.3004 18.2813 12.5947C18.4131 13.4391 18.8227 14.216 19.4456 14.8032C20.0686 15.3904 20.8696 15.7546 21.7229 15.8386C22.0181 15.8674 22.2341 16.1329 22.2053 16.4272C22.1693 16.6999 21.9317 16.908 21.6581 16.908Z"
                                  fill="black"
                                />
                                <path
                                  d="M24.2944 25.3769H11.3344C11.0392 25.3769 10.7944 25.1321 10.7944 24.8369C10.7944 24.5417 11.0392 24.2969 11.3344 24.2969H24.2944C24.5896 24.2969 24.8344 24.5417 24.8344 24.8369C24.8344 25.1321 24.5896 25.3769 24.2944 25.3769Z"
                                  fill="black"
                                />
                              </svg>
                            </div>
                          ) : (
                            ""
                          )}
                        </button>
                      </div>
                      <div className="profile-item">
                        <p>
                          {userData?.gender == "1"
                            ? (ingerman=="de" ?  "Männlich":"Male")
                            : userData?.gender == "0"
                            ? (ingerman=="de" ?"Weiblich" : "Female")
                            : (ingerman=="de" ?"Mache lieber keine Angabe" : "Prefer not to say")}
                        </p>
                        <p  style={{ textTransform: "none" }}>{userData?.email}</p>
                      </div>
                      <div className="profile-item">
                        <p>
                          {userData?.country_code} {userData?.phone_number}
                        </p>
                        <p>{userData?.language}</p>
                      </div>
                    </div>

                    <hr />
                    <div className="biography-details">
                      <div className="d-flex align-items-center justify-content-between">
                        <h3>{ingerman=="de" ? "Standort" : "Location"}</h3>
                        <button>
                          {edit ? (
                            <div onClick={() => navigate("/edit-profile")}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                              >
                                <rect
                                  width="36"
                                  height="36"
                                  rx="18"
                                  fill="white"
                                />
                                <path
                                  d="M13.1596 23.0561C12.7204 23.0561 12.31 22.9054 12.0148 22.6255C11.6404 22.2738 11.4604 21.7427 11.5252 21.1686L11.7916 18.8432C11.842 18.4054 12.1084 17.8241 12.418 17.5083L18.3292 11.2716C19.8052 9.71418 21.346 9.67112 22.9084 11.1424C24.4708 12.6137 24.514 14.1495 23.038 15.7069L17.1268 21.9437C16.8244 22.2666 16.2628 22.5681 15.8236 22.6398L13.5052 23.0346C13.3828 23.0417 13.2748 23.0561 13.1596 23.0561ZM20.6404 11.1352C20.086 11.1352 19.6036 11.4797 19.114 11.9964L13.2028 18.2404C13.0588 18.3911 12.8932 18.7499 12.8644 18.9581L12.598 21.2834C12.5692 21.5202 12.6268 21.714 12.7564 21.836C12.886 21.958 13.0804 22.0011 13.318 21.9652L15.6364 21.5705C15.8452 21.5346 16.1908 21.348 16.3348 21.1973L22.246 14.9605C23.1388 14.0132 23.4628 13.1376 22.1596 11.9175C21.5836 11.3649 21.0868 11.1352 20.6404 11.1352Z"
                                  fill="black"
                                />
                                <path
                                  d="M21.6581 16.908H21.6077C20.5165 16.8013 19.492 16.3358 18.6955 15.5847C17.899 14.8337 17.3758 13.8398 17.2085 12.7597C17.1653 12.4655 17.3669 12.1928 17.6621 12.1425C17.9573 12.0995 18.2309 12.3004 18.2813 12.5947C18.4131 13.4391 18.8227 14.216 19.4456 14.8032C20.0686 15.3904 20.8696 15.7546 21.7229 15.8386C22.0181 15.8674 22.2341 16.1329 22.2053 16.4272C22.1693 16.6999 21.9317 16.908 21.6581 16.908Z"
                                  fill="black"
                                />
                                <path
                                  d="M24.2944 25.3769H11.3344C11.0392 25.3769 10.7944 25.1321 10.7944 24.8369C10.7944 24.5417 11.0392 24.2969 11.3344 24.2969H24.2944C24.5896 24.2969 24.8344 24.5417 24.8344 24.8369C24.8344 25.1321 24.5896 25.3769 24.2944 25.3769Z"
                                  fill="black"
                                />
                              </svg>
                            </div>
                          ) : (
                            ""
                          )}
                        </button>
                      </div>
                      <p>{userData?.address}</p>
                    </div>
                    <div className="biography-details">
                      <div className="d-flex align-items-center justify-content-between">
                        <h3>{ingerman=="de" ? "Coach Titel" : "Coach Title"}</h3>
                        <button>
                          {edit ? (
                            <div
                              onClick={() =>
                                navigate("/create-profile-three", {
                                  state: {
                                    edit: "edit",
                                  },
                                })
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                              >
                                <rect
                                  width="36"
                                  height="36"
                                  rx="18"
                                  fill="white"
                                />
                                <path
                                  d="M13.1596 23.0561C12.7204 23.0561 12.31 22.9054 12.0148 22.6255C11.6404 22.2738 11.4604 21.7427 11.5252 21.1686L11.7916 18.8432C11.842 18.4054 12.1084 17.8241 12.418 17.5083L18.3292 11.2716C19.8052 9.71418 21.346 9.67112 22.9084 11.1424C24.4708 12.6137 24.514 14.1495 23.038 15.7069L17.1268 21.9437C16.8244 22.2666 16.2628 22.5681 15.8236 22.6398L13.5052 23.0346C13.3828 23.0417 13.2748 23.0561 13.1596 23.0561ZM20.6404 11.1352C20.086 11.1352 19.6036 11.4797 19.114 11.9964L13.2028 18.2404C13.0588 18.3911 12.8932 18.7499 12.8644 18.9581L12.598 21.2834C12.5692 21.5202 12.6268 21.714 12.7564 21.836C12.886 21.958 13.0804 22.0011 13.318 21.9652L15.6364 21.5705C15.8452 21.5346 16.1908 21.348 16.3348 21.1973L22.246 14.9605C23.1388 14.0132 23.4628 13.1376 22.1596 11.9175C21.5836 11.3649 21.0868 11.1352 20.6404 11.1352Z"
                                  fill="black"
                                />
                                <path
                                  d="M21.6581 16.908H21.6077C20.5165 16.8013 19.492 16.3358 18.6955 15.5847C17.899 14.8337 17.3758 13.8398 17.2085 12.7597C17.1653 12.4655 17.3669 12.1928 17.6621 12.1425C17.9573 12.0995 18.2309 12.3004 18.2813 12.5947C18.4131 13.4391 18.8227 14.216 19.4456 14.8032C20.0686 15.3904 20.8696 15.7546 21.7229 15.8386C22.0181 15.8674 22.2341 16.1329 22.2053 16.4272C22.1693 16.6999 21.9317 16.908 21.6581 16.908Z"
                                  fill="black"
                                />
                                <path
                                  d="M24.2944 25.3769H11.3344C11.0392 25.3769 10.7944 25.1321 10.7944 24.8369C10.7944 24.5417 11.0392 24.2969 11.3344 24.2969H24.2944C24.5896 24.2969 24.8344 24.5417 24.8344 24.8369C24.8344 25.1321 24.5896 25.3769 24.2944 25.3769Z"
                                  fill="black"
                                />
                              </svg>
                            </div>
                          ) : (
                            ""
                          )}
                        </button>
                      </div>
                      <p>{userData?.coachTitle}</p>
                    </div>
                    <hr />
                    <div className="biography-details">
                      <div className="d-flex align-items-center justify-content-between">
                        <h3>{ingerman=="de" ? "Honorar" : "Rate"}</h3>
                        <button>
                          {edit ? (
                            <div
                              onClick={() =>
                                navigate("/create-profile-rate", {
                                  state: {
                                    edit: "edit",
                                  },
                                })
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                              >
                                <rect
                                  width="36"
                                  height="36"
                                  rx="18"
                                  fill="white"
                                />
                                <path
                                  d="M13.1596 23.0561C12.7204 23.0561 12.31 22.9054 12.0148 22.6255C11.6404 22.2738 11.4604 21.7427 11.5252 21.1686L11.7916 18.8432C11.842 18.4054 12.1084 17.8241 12.418 17.5083L18.3292 11.2716C19.8052 9.71418 21.346 9.67112 22.9084 11.1424C24.4708 12.6137 24.514 14.1495 23.038 15.7069L17.1268 21.9437C16.8244 22.2666 16.2628 22.5681 15.8236 22.6398L13.5052 23.0346C13.3828 23.0417 13.2748 23.0561 13.1596 23.0561ZM20.6404 11.1352C20.086 11.1352 19.6036 11.4797 19.114 11.9964L13.2028 18.2404C13.0588 18.3911 12.8932 18.7499 12.8644 18.9581L12.598 21.2834C12.5692 21.5202 12.6268 21.714 12.7564 21.836C12.886 21.958 13.0804 22.0011 13.318 21.9652L15.6364 21.5705C15.8452 21.5346 16.1908 21.348 16.3348 21.1973L22.246 14.9605C23.1388 14.0132 23.4628 13.1376 22.1596 11.9175C21.5836 11.3649 21.0868 11.1352 20.6404 11.1352Z"
                                  fill="black"
                                />
                                <path
                                  d="M21.6581 16.908H21.6077C20.5165 16.8013 19.492 16.3358 18.6955 15.5847C17.899 14.8337 17.3758 13.8398 17.2085 12.7597C17.1653 12.4655 17.3669 12.1928 17.6621 12.1425C17.9573 12.0995 18.2309 12.3004 18.2813 12.5947C18.4131 13.4391 18.8227 14.216 19.4456 14.8032C20.0686 15.3904 20.8696 15.7546 21.7229 15.8386C22.0181 15.8674 22.2341 16.1329 22.2053 16.4272C22.1693 16.6999 21.9317 16.908 21.6581 16.908Z"
                                  fill="black"
                                />
                                <path
                                  d="M24.2944 25.3769H11.3344C11.0392 25.3769 10.7944 25.1321 10.7944 24.8369C10.7944 24.5417 11.0392 24.2969 11.3344 24.2969H24.2944C24.5896 24.2969 24.8344 24.5417 24.8344 24.8369C24.8344 25.1321 24.5896 25.3769 24.2944 25.3769Z"
                                  fill="black"
                                />
                              </svg>
                            </div>
                          ) : (
                            ""
                          )}
                        </button>
                      </div>
                      <p>€ {userData?.rateperhour}/H</p>
                    </div>
                    <hr />
                    <div className="biography-details">
                      <div className="d-flex align-items-center justify-content-between">
                        <h3>{ingerman=="de" ? "Biografie" : "Biography"}</h3>
                        <button>
                          {edit ? (
                            <div
                              onClick={() =>
                                navigate("/create-profile-three", {
                                  state: {
                                    edit: "edit",
                                  },
                                })
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                              >
                                <rect
                                  width="36"
                                  height="36"
                                  rx="18"
                                  fill="white"
                                />
                                <path
                                  d="M13.1596 23.0561C12.7204 23.0561 12.31 22.9054 12.0148 22.6255C11.6404 22.2738 11.4604 21.7427 11.5252 21.1686L11.7916 18.8432C11.842 18.4054 12.1084 17.8241 12.418 17.5083L18.3292 11.2716C19.8052 9.71418 21.346 9.67112 22.9084 11.1424C24.4708 12.6137 24.514 14.1495 23.038 15.7069L17.1268 21.9437C16.8244 22.2666 16.2628 22.5681 15.8236 22.6398L13.5052 23.0346C13.3828 23.0417 13.2748 23.0561 13.1596 23.0561ZM20.6404 11.1352C20.086 11.1352 19.6036 11.4797 19.114 11.9964L13.2028 18.2404C13.0588 18.3911 12.8932 18.7499 12.8644 18.9581L12.598 21.2834C12.5692 21.5202 12.6268 21.714 12.7564 21.836C12.886 21.958 13.0804 22.0011 13.318 21.9652L15.6364 21.5705C15.8452 21.5346 16.1908 21.348 16.3348 21.1973L22.246 14.9605C23.1388 14.0132 23.4628 13.1376 22.1596 11.9175C21.5836 11.3649 21.0868 11.1352 20.6404 11.1352Z"
                                  fill="black"
                                />
                                <path
                                  d="M21.6581 16.908H21.6077C20.5165 16.8013 19.492 16.3358 18.6955 15.5847C17.899 14.8337 17.3758 13.8398 17.2085 12.7597C17.1653 12.4655 17.3669 12.1928 17.6621 12.1425C17.9573 12.0995 18.2309 12.3004 18.2813 12.5947C18.4131 13.4391 18.8227 14.216 19.4456 14.8032C20.0686 15.3904 20.8696 15.7546 21.7229 15.8386C22.0181 15.8674 22.2341 16.1329 22.2053 16.4272C22.1693 16.6999 21.9317 16.908 21.6581 16.908Z"
                                  fill="black"
                                />
                                <path
                                  d="M24.2944 25.3769H11.3344C11.0392 25.3769 10.7944 25.1321 10.7944 24.8369C10.7944 24.5417 11.0392 24.2969 11.3344 24.2969H24.2944C24.5896 24.2969 24.8344 24.5417 24.8344 24.8369C24.8344 25.1321 24.5896 25.3769 24.2944 25.3769Z"
                                  fill="black"
                                />
                              </svg>
                            </div>
                          ) : (
                            ""
                          )}
                        </button>
                      </div>
                      <p>{userData?.coachBio}</p>
                    </div>
                    <hr />
                    <div className="availability-details">
                      <div className="d-flex align-items-center justify-content-between">
                        <h3>{ingerman=="de" ? "Verfügbarkeit" : "Availability"}</h3>
                        <button>
                        {edit ? (
                            <div
                              onClick={() =>
                                navigate("/time-availability", {
                                  state: {
                                    edit: "edit",
                                  },
                                })
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                              >
                                <rect
                                  width="36"
                                  height="36"
                                  rx="18"
                                  fill="white"
                                />
                                <path
                                  d="M13.1596 23.0561C12.7204 23.0561 12.31 22.9054 12.0148 22.6255C11.6404 22.2738 11.4604 21.7427 11.5252 21.1686L11.7916 18.8432C11.842 18.4054 12.1084 17.8241 12.418 17.5083L18.3292 11.2716C19.8052 9.71418 21.346 9.67112 22.9084 11.1424C24.4708 12.6137 24.514 14.1495 23.038 15.7069L17.1268 21.9437C16.8244 22.2666 16.2628 22.5681 15.8236 22.6398L13.5052 23.0346C13.3828 23.0417 13.2748 23.0561 13.1596 23.0561ZM20.6404 11.1352C20.086 11.1352 19.6036 11.4797 19.114 11.9964L13.2028 18.2404C13.0588 18.3911 12.8932 18.7499 12.8644 18.9581L12.598 21.2834C12.5692 21.5202 12.6268 21.714 12.7564 21.836C12.886 21.958 13.0804 22.0011 13.318 21.9652L15.6364 21.5705C15.8452 21.5346 16.1908 21.348 16.3348 21.1973L22.246 14.9605C23.1388 14.0132 23.4628 13.1376 22.1596 11.9175C21.5836 11.3649 21.0868 11.1352 20.6404 11.1352Z"
                                  fill="black"
                                />
                                <path
                                  d="M21.6581 16.908H21.6077C20.5165 16.8013 19.492 16.3358 18.6955 15.5847C17.899 14.8337 17.3758 13.8398 17.2085 12.7597C17.1653 12.4655 17.3669 12.1928 17.6621 12.1425C17.9573 12.0995 18.2309 12.3004 18.2813 12.5947C18.4131 13.4391 18.8227 14.216 19.4456 14.8032C20.0686 15.3904 20.8696 15.7546 21.7229 15.8386C22.0181 15.8674 22.2341 16.1329 22.2053 16.4272C22.1693 16.6999 21.9317 16.908 21.6581 16.908Z"
                                  fill="black"
                                />
                                <path
                                  d="M24.2944 25.3769H11.3344C11.0392 25.3769 10.7944 25.1321 10.7944 24.8369C10.7944 24.5417 11.0392 24.2969 11.3344 24.2969H24.2944C24.5896 24.2969 24.8344 24.5417 24.8344 24.8369C24.8344 25.1321 24.5896 25.3769 24.2944 25.3769Z"
                                  fill="black"
                                />
                              </svg>
                            </div>
                          ) : (
                            ""
                          )}
                        </button>
                      </div>
                      <div className="availability-days">
                        <ul>
                          {data?.data?.availability?.map((time) => {
                            {/* const lastIndex = data?.data?.availability.length - 1; */}
                            const dayTranslation =
                              dayTranslations[time.day];
                            return (
                              <li>
                                <p>{ingerman=="de" ? dayTranslation :time?.day}</p>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                    <hr />
                    <div className="availability-details">
                      <div className="d-flex align-items-center justify-content-between">
                        <h3>{ingerman=="de" ? "Zertifikat" : "Certificate"}</h3>
                        <button>
                          {edit ? (
                            <div onClick={() => navigate("/upload-certificate",{
                                  state: {
                                    edit: "edit",
                                  },
                                })}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                              >
                                <rect
                                  width="36"
                                  height="36"
                                  rx="18"
                                  fill="white"
                                />
                                <path
                                  d="M13.1596 23.0561C12.7204 23.0561 12.31 22.9054 12.0148 22.6255C11.6404 22.2738 11.4604 21.7427 11.5252 21.1686L11.7916 18.8432C11.842 18.4054 12.1084 17.8241 12.418 17.5083L18.3292 11.2716C19.8052 9.71418 21.346 9.67112 22.9084 11.1424C24.4708 12.6137 24.514 14.1495 23.038 15.7069L17.1268 21.9437C16.8244 22.2666 16.2628 22.5681 15.8236 22.6398L13.5052 23.0346C13.3828 23.0417 13.2748 23.0561 13.1596 23.0561ZM20.6404 11.1352C20.086 11.1352 19.6036 11.4797 19.114 11.9964L13.2028 18.2404C13.0588 18.3911 12.8932 18.7499 12.8644 18.9581L12.598 21.2834C12.5692 21.5202 12.6268 21.714 12.7564 21.836C12.886 21.958 13.0804 22.0011 13.318 21.9652L15.6364 21.5705C15.8452 21.5346 16.1908 21.348 16.3348 21.1973L22.246 14.9605C23.1388 14.0132 23.4628 13.1376 22.1596 11.9175C21.5836 11.3649 21.0868 11.1352 20.6404 11.1352Z"
                                  fill="black"
                                />
                                <path
                                  d="M21.6581 16.908H21.6077C20.5165 16.8013 19.492 16.3358 18.6955 15.5847C17.899 14.8337 17.3758 13.8398 17.2085 12.7597C17.1653 12.4655 17.3669 12.1928 17.6621 12.1425C17.9573 12.0995 18.2309 12.3004 18.2813 12.5947C18.4131 13.4391 18.8227 14.216 19.4456 14.8032C20.0686 15.3904 20.8696 15.7546 21.7229 15.8386C22.0181 15.8674 22.2341 16.1329 22.2053 16.4272C22.1693 16.6999 21.9317 16.908 21.6581 16.908Z"
                                  fill="black"
                                />
                                <path
                                  d="M24.2944 25.3769H11.3344C11.0392 25.3769 10.7944 25.1321 10.7944 24.8369C10.7944 24.5417 11.0392 24.2969 11.3344 24.2969H24.2944C24.5896 24.2969 24.8344 24.5417 24.8344 24.8369C24.8344 25.1321 24.5896 25.3769 24.2944 25.3769Z"
                                  fill="black"
                                />
                              </svg>
                            </div>
                          ) : (
                            ""
                          )}
                        </button>
                      </div>
                      <div className="certificate-img">
                      {userData?.certification && (
                          <>
                            {userData.certification.endsWith(".pdf") ? (
                              <embed
                                src={`${BASE_URL}${userData.certification}`}
                                type="application/pdf"
                                width="100%"
                                height="300px"
                              />
                            ) : (
                              <img
                                src={`${BASE_URL}${userData.certification}`}
                                alt="Certificate"
                              />
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    {/* <div className="coach-certificate">
                      <div className="d-flex align-items-center justify-content-between">
                        <h3>Certificate</h3>
                      

                
                      </div>
                    </div> */}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </LayoutCoach>
    </>
  );
}
